var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"noData"},[_c('img',{style:({width: _vm.imgWidth + 'px'}),attrs:{"src":require("@/static/noData.png")},on:{"load":_vm.handleImageLoad}}),(_vm.isDelayShowStr && _vm.isShowStr)?_c('span',[_vm._v(_vm._s(_vm.str))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }